import { Group } from "@dashboard-v3/api";
import { useState } from "react";
import useSWR from "swr";
import { fetchGroup } from "utils/api/groups";

type ApprovalGroupInAccount = {
  approvalGroup?: string;
  approvalGroups?: string[];
};

/** 1 minuto */
const ttl = 1 * 60 * 1000;

/*
const groupCache = new Map<string, any>();
*/
export default function useApprovalGroups(
  account: ApprovalGroupInAccount,
  lazy = true
) {
  const [fetch, setFetch] = useState(!lazy);

  const ids = [];
  if (account && account.approvalGroup) {
    ids.push(account.approvalGroup);
  }
  if (account && account.approvalGroups) {
    ids.push(...account.approvalGroups);
  }

  const hasIds = ids.length > 0;

  // Crear key de cache basada en IDs ordenados
  const cacheKey = hasIds ? `groups:${ids.join(",")}` : null;

  const { data, isLoading } = useSWR(
    fetch ? cacheKey : null,
    () => fetchMultipleGroups(ids),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      dedupingInterval: ttl, // 1 minuto
      errorRetryCount: 2,
    }
  );

  return {
    isLoading: fetch && isLoading,
    approvalGroups: data,
    initLoad: () => setFetch(true),
  };
}

async function fetchMultipleGroups(ids: string[]) {
  const results = await Promise.allSettled(ids.map(id => fetchGroup(id)));
  const groups: Group[] = [];

  results.forEach(result => {
    if (result.status === "fulfilled") {
      groups.push(result.value);
    }
  });

  return groups;
}

/*
  const invalidateGroup = (groupId: string) => {
    groupCache.delete(groupId);
    // Re-fetch si este grupo está en la lista actual
    if (ids.includes(groupId)) {
      mutate();
    }
  };

  return {
    isLoading,
    approvalGroups: data?.groups || [],
    error: data?.hasErrors ? data.errors[0]?.error : error,
    invalidateGroup, // Función para invalidar cache específico
    initiateFetch: () => !lazy && setFetch(true), // Función para iniciar fetch
  };
}

// Fetcher para un grupo individual con cache manual
const fetchGroupWithCache = async (id: string) => {
  // Verificar cache local primero
  if (groupCache.has(id)) {
    return groupCache.get(id);
  }

  try {
    console.log("Fetching group id:", id);
    const group = await fetchGroup(id);
    groupCache.set(id, group);
    setTimeout(() => groupCache.delete(id), ttl);
    return group;
  } catch (error) {
    // No cachear errores para permitir reintentos
    throw error;
  }
};

// Fetcher optimizado para múltiples grupos
const fetchMultipleGroups = async (ids: string[]) => {
  const results = await Promise.allSettled(
    ids.map(id => fetchGroupWithCache(id))
  );

  console.log("results: ", results);

  const groups: Group[] = [];
  const errors: { id: string; error: any }[] = [];

  results.forEach((result, index) => {
    if (result.status === "fulfilled") {
      groups.push(result.value);
    } else {
      errors.push({
        id: ids[index],
        error: result.reason,
      });
    }
  });

  return {
    groups,
    errors,
    hasErrors: errors.length > 0,
  };
};
*/
